<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>
   Compliance Item
  </li> 
</ul>

<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Compliance Item </strong>
    </span>
    <span style="float: right">
      <button class="btn btn-sm btn-primary" type="button" data-target="#groupDialog" (click)="showAddPopUp()"
        [appHasPermission]="{'Url': '/group/edit?goveva=true&email=', 'method':'put', 'menu': 'Tag'}">
        <em class="fa fa-plus"></em> Add Compliance</button>
    </span>
  </div>
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">

          <div class="table-responsive">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap stripe"
              id="groupTable" style="cursor: pointer;">
              <caption></caption>
              <thead>
                <tr>
                  <th scope="row">Compliance Confirmation Item </th>
                  <th scope="row" class="group-list-action"><span [appHasPermission]="{'Url': '/group/edit?goveva=true&email=', 'method':'put', 'menu': 'Tag'}">Action</span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let complianceItem of complianceItems;">
                  <td tabindex="1">{{complianceItem.complianceName }}</td>
                  <td class="group-list-action">
                    <button type="button" class="btn-sm btn btn-warning" (click)="getComplianceById(complianceItem._id)" [appHasPermission]="{'Url': '/group/edit?goveva=true&email=', 'method':'put', 'menu': 'Tag'}">
                      <span class="fa fa-pencil"></span>
                    </button>&nbsp;&nbsp;&nbsp;
                    <button type="button" class="btn-sm btn btn-danger" (click)="deleteConfirmation(complianceItem._id)" [appHasPermission]="{'Url': '/group/edit?goveva=true&email=', 'method':'put', 'menu': 'Tag'}">
                      <span class="icmn-bin"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>

          <div class="modal fade modal-size-medium" id="groupDialog" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <form [formGroup]="complianceItemForm" class="well">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabel">Compliance</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <em class="fa fa-times"></em>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-3">
                        <label class="form-control-label" for="l0">Compliance Confirmation Item
                          <span _ngcontent-c2="" style="color: red;">*</span>
                        </label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">

                          <input [formControl]="complianceItemForm.controls['complianceName']" class="form-control" id="complianceName">
                          <div *ngIf="complianceItemForm.controls['complianceName'].hasError('required') && complianceItemForm.controls['complianceName'].touched"
                            class="form-control-error-custom">
                            Compliance confirmation item is required.
                          </div>
                          <div *ngIf="complianceItemForm.controls['complianceName'].hasError('pattern') && complianceItemForm.controls['complianceName'].touched" class="form-control-error-custom">
                            Please enter a valid Compliance confirmation item.
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="modal-footer">
                    <button id="btnsaveGroup" type="button" class="btn btn-sm btn-primary" [disabled]="!complianceItemForm.valid" (click)="addComplianceItem()">
                      <i class="fa fa-save"></i>Save
                    </button>
                    <button id="btnupdateGroup" style="display:none;" type="button" class="btn btn-sm btn-primary" [disabled]="!complianceItemForm.valid"
                      (click)="editComplianceItem()">
                      <i class="fa fa-save"></i>Update
                    </button>
                    <button type="button" class="btn btn-sm" data-dismiss="modal">
                      <i class="fa fa-times"></i>Close
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>



          <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="myModalLabelForDelete">
                    <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-sm-12">
                      Are you sure you want to delete the Tag?
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">
                    <i class="fa fa-times"></i>No
                  </button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="deleteComplianceItem()">
                    <i class="fa fa-check"></i>Yes
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<app-alert></app-alert>